import React, { Component } from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { Row, Col } from 'react-bootstrap';
import loader from '../../assets/loader.svg';
import PropTypes from 'prop-types';
import ScrollArea from 'react-scrollbar';
import _ from 'lodash';
import actionTypes from '../../redux/actionTypes';
import actions from '../../redux/actions';
import Deal from './Deal';
import { selectDealsState, selectInvitesState } from '../../redux/selectors';

class DealsList extends Component {
  constructor() {
    super();
    this.state = {
      deals: null,
      loading: 'init',
      loadingDeal: 'init',
    };
  }

  componentWillMount() {
    const { profile } = this.props;

    if (profile && profile.id) {
      this.props.loadDeals(profile.id);
      this.props.loadDealInvites(profile.id);
    }
  }

  componentWillReceiveProps(nextProps) {
    const { profile, inviteStatus, dealStatus, invites, deals } = nextProps;

    if (profile && profile.id !== this.props.profile.id) {
      this.props.loadDeals(profile.id);
      this.props.loadDealInvites(profile.id);
    }

    if (this.props.inviteStatus !== inviteStatus) {
      if (
        inviteStatus === actionTypes.INVITES_USER_GET_REQUEST &&
        invites.length === 0
      ) {
        this.setState({ loading: 'loading' });
      } else if (
        inviteStatus === actionTypes.INVITES_USER_GET_SUCCESS ||
        inviteStatus === actionTypes.INVITES_USER_GET_ERROR
      ) {
        this.setState({ loading: 'loaded' });
      }
    }
    if (this.props.dealStatus !== dealStatus) {
      if (
        dealStatus === actionTypes.DEALS_USER_GET_REQUEST &&
        (!deals || deals.length === 0)
      ) {
        this.setState({ loadingDeal: 'loading' });
      } else if (
        dealStatus === actionTypes.DEALS_USER_GET_SUCCESS ||
        dealStatus === actionTypes.DEALS_USER_GET_ERROR
      ) {
        this.setState({ loadingDeal: 'loaded' });
      }
    }
  }

  handleDealClick = (e, dealInfo, inviteType = 'member') => {
    e.preventDefault();

    this.props.selectDeal(dealInfo);

    if (inviteType === 'member') {
      this.props.router.push(`/dealroom/${dealInfo.id}/edit/`);
    } else {
      this.props.router.push(`/dealroom/${dealInfo.id}/edit/`);
    }
  };

  renderDeals = () => {
    let { deals, searchText, profile, showArchivedDeal } = this.props;

    if (showArchivedDeal) {
      deals = deals.filter(
        (deal) =>
          deal.agreement_info &&
          deal.agreement_info.name
            .toLowerCase()
            .includes(searchText.toLowerCase()) &&
          deal.progress !== 100 &&
          deal.agreement_info.archived === true &&
          deal.user === profile.id
      );
    } else {
      deals = deals.filter(
        (deal) =>
          deal.agreement_info &&
          deal.agreement_info.name
            .toLowerCase()
            .includes(searchText.toLowerCase()) &&
          deal.progress !== 100 &&
          deal.agreement_info.archived === false &&
          deal.user === profile.id
      );
    }

    if (deals.length > 0) {
      deals = _.orderBy(
        deals,
        [(deal) => deal.agreement_info.name.toLowerCase()],
        ['asc']
      );
      deals = _.orderBy(
        deals,
        [(deal) => deal.agreement_info.date_created],
        ['desc']
      );

      return deals.map((deal, i) => {
        return (
          <Deal
            key={i}
            deal={deal}
            onClick={(e) => this.handleDealClick(e, deal)}
          />
        );
      });
    } else if (this.state.loadingDeal === 'loaded') {
      return (
        <div>
          <p className="text-center">You have no pending agreements :(</p>
        </div>
      );
    }
  };

  renderDealInvites = () => {
    let { pageType, profile, invites } = this.props;

    if (invites.length > 0) {
      invites = this.filterUnarchivedDealInvite(invites);

      if (pageType === 'dashboard') {
        invites = _.orderBy(
          invites,
          [(invite) => invite.deal_info.date_created],
          ['desc']
        );
      } else {
        invites = invites.filter(
          (invite) => invite.deal_info.user !== profile.id
        );

        invites = _.orderBy(
          invites,
          [
            (invite) => invite.deal_info.agreement_info.name.toLowerCase(),
            'deal_info.agreement_info.date_created',
          ],
          ['asc', 'desc']
        );
      }

      return invites.map((invite, i) => {
        return (
          <Deal
            key={i}
            deal={invite.deal_info}
            onClick={(e) =>
              this.handleDealClick(e, invite.deal_info, invite.type)
            }
            type={this.props.pageType}
          />
        );
      });
    } else if (this.state.loading === 'loaded') {
      return (
        <div>
          <p className="text-center">There are no new invitations :(</p>
        </div>
      );
    }
  };

  filterUnarchivedDealInvite = (invites) => {
    const { searchText } = this.props;
    let filteredInvites = [];

    // filter invitees who have unarchived deals
    filteredInvites = invites.filter((invite) =>
      invite.deal_info.agreement_info
        ? invite.deal_info.agreement_info.archived === false
        : false
    );

    // filter final invitees who have uncompleted deals (not 100%)
    filteredInvites = filteredInvites.filter((invite) =>
      invite.deal_info.agreement_info
        ? invite.deal_info.agreement_info.name
            .toLowerCase()
            .includes(searchText.toLowerCase()) &&
          invite.deal_info.progress !== 100
        : false
    );

    return filteredInvites;
  };

  render() {
    const { pageType, invites, deals } = this.props;
    const { loading, loadingDeal } = this.state;

    if (pageType === 'dashboard') {
      // show invitees who have unarchived and uncompleted deals in the dashboard list
      const filteredInvites = this.filterUnarchivedDealInvite(invites);

      return (
        <Row>
          <Col md={12} sm={12} className="agreements-dash">
            {loading === 'loading' && (
              <div className="loader">
                <img src={loader} alt="Loading spinner" />
              </div>
            )}

            {filteredInvites.length > 0 ? (
              <div>
                <div className="dash-deal-title">
                  <h1>View All Registrations</h1>
                  <div className="review-label">
                    <span>{filteredInvites.length} to review</span>
                  </div>
                </div>
                <div className="agreement-wrapper">
                  {this.renderDealInvites()}
                </div>
              </div>
            ) : null}
          </Col>
        </Row>
      );
    }

    if (deals.length === 0 && invites.length === 0) {
      return null;
    } else {
      return (
        <div className="deals-list">
          {loadingDeal === 'loading' || loading === 'loading' ? (
            <div className="loader">
              <img src={loader} alt="Loading spinner" />
            </div>
          ) : (
            <Row>
              <Col md={6}>
                <h4 className="agreement-header">Agreements You Have Sent</h4>
                <ScrollArea
                  className="agreement-wrapper"
                  horizontal={false}
                  verticalContainerStyle={{ background: 'transparent' }}
                  verticalScrollbarStyle={{ background: '#11a7d8' }}
                  smoothScrolling
                  stopScrollPropagation
                >
                  {this.renderDeals()}
                </ScrollArea>
              </Col>
              <Col md={6}>
                <h4 className="agreement-header">
                  Agreements You Are Invited To
                </h4>
                <ScrollArea
                  className="agreement-wrapper"
                  horizontal={false}
                  verticalContainerStyle={{ background: 'transparent' }}
                  verticalScrollbarStyle={{ background: '#11a7d8' }}
                  smoothScrolling
                  stopScrollPropagation
                >
                  {this.renderDealInvites()}
                </ScrollArea>
              </Col>
            </Row>
          )}
        </div>
      );
    }
  }
}

DealsList.defaultProps = {
  searchText: '',
  showArchivedDeal: false,
};

DealsList.propTypes = {
  searchText: PropTypes.string,
  showArchivedDeal: PropTypes.bool,
};

const mapStateToProps = (state) => ({
  profile: state.profile,
  deals: selectDealsState(state),
  invites: selectInvitesState(state),
  inviteStatus: state.invites.status,
  dealStatus: state.deals.status,
});

const mapDispatchToProps = (dispatch, state) => ({
  loadDeals: (userId) => {
    dispatch(actions.getUserDeals(userId));
  },
  loadDealInvites: (userId) => {
    dispatch(actions.getUserInvites(userId));
  },
  selectDeal: (deal) => {
    dispatch(actions.selectDeal(deal));
  },
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(DealsList));



// WEBPACK FOOTER //
// src/components/Deals/DealsList.jsx